//scss
import "./style.scss";

const ListingTwoColGrid = ({ list }) => {
	return <div className="listing__2-col-grid ">{list.map((item) => item)}</div>;
};

export default ListingTwoColGrid;
